import { createContext, useContext } from 'react';
export const FieldPropsContext = createContext(undefined);
export function useFieldProps() {
    const context = useContext(FieldPropsContext);
    if (typeof context === 'undefined') {
        throw new Error('useFieldProps must be used within a FieldPropsProvider');
    }
    return context;
}
export function useFieldPropsV2() {
    return useFieldProps().v2;
}

//# sourceMappingURL=field-props-context.js.map